// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import store from './store'
import ReviewWidget from '@/pages/ReviewWidget'
import BaseReviewEntryNotice from '@/components/BaseReviewEntryNotice'
import BaseReviewSummary from '@/components/BaseReviewSummary'
import { formatRating, formatRatingClassName, formatRelativeDate, formatDateString } from './filters/formatter'

Vue.config.productionTip = false

Vue.filter('formatRating', formatRating)
Vue.filter('formatRatingClassName', formatRatingClassName)
Vue.filter('formatRelativeDate', formatRelativeDate)
Vue.filter('formatDateString', formatDateString)

const props = {
  sortValue: 'review_date_desc',
  refineValue: 'review_star_all',
  pageSize: 3,
  pageSizeMore: 5,
  pageTopImgs: {
    maxSize: 12,
    sortValue: 'review_helpful_desc'
  }
}

// const debug = process.env.NODE_ENV === 'development'
const urlSplit = location.pathname.split('/')
// const skuCode = !debug ? urlSplit[urlSplit.length - 1] : '4550002184971'
const skuCode = urlSplit[urlSplit.length - 1]

/* eslint-disable no-new */
new Vue({
  el: '#review-widget',
  store,
  template: '<ReviewWidget />',
  components: { ReviewWidget },
  render: function (createElement) {
    this.$store.dispatch('commons/setCookies')
    const pageSize = this.$el.getAttribute('data-page-size')
    const pageSizeMore = this.$el.getAttribute('data-page-size-more')
    this.$store.dispatch('storeReviews/initialize', {
      sortValue: props.sortValue,
      refineValue: props.refineValue,
      pageSize: Number(pageSize) || props.pageSize,
      pageSizeMore: Number(pageSizeMore) || props.pageSizeMore,
      isRenderHelpful: true,
      isRenderClip: false,
      isRenderModal: false,
      targetSku: skuCode,
      pageTopImgs: {
        maxSize: props.pageTopImgs.maxSize,
        sortValue: props.pageTopImgs.sortValue
      },
      linkTargetSku: skuCode
    })
    return createElement('ReviewWidget')
  }/* ,
  ready: function () {
    if (window.$) {
      const $ = window.$
      $(window).on('load resize', function () {
        $('[data-src]').each(function () {
          var w = $(this).width()
          $(this).height(w)
        })
      }).on('load', function () {
        $('[data-src] img').each(function () {
          var w = this.naturalWidth
          var h = this.naturalHeight
          if (w > h) {
            $(this).addClass('fit-height')
          } else if (w < h) {
            $(this).addClass('fit-width')
          }
        })
        window.initPhotoSwipeFromDOM('.photoswipeGroup', '.photoswipeImages')
      })
    }
  } */
})

new Vue({
  el: '#entry-notice',
  store,
  template: '<BaseReviewEntryNotice />',
  components: { BaseReviewEntryNotice },
  render: function (createElement) {
    this.$store.dispatch('commons/setCookies')
    this.$store.dispatch('storePurchase/initialize', {
      targetSku: skuCode
    })
    return createElement('BaseReviewEntryNotice')
  }
})

new Vue({
  el: '#review-summary',
  store,
  template: '<BaseReviewSummary />',
  components: { BaseReviewSummary },
  render: function (createElement) {
    this.$store.dispatch('commons/setCookies')
    return createElement('BaseReviewSummary')
  }
})



// WEBPACK FOOTER //
// ./src/review-widget.js